import { render, staticRenderFns } from "./SynonymList.vue?vue&type=template&id=87030096&"
import script from "./SynonymList.vue?vue&type=script&lang=js&"
export * from "./SynonymList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87030096')) {
      api.createRecord('87030096', component.options)
    } else {
      api.reload('87030096', component.options)
    }
    module.hot.accept("./SynonymList.vue?vue&type=template&id=87030096&", function () {
      api.rerender('87030096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymList/components/mobile/SynonymList.vue"
export default component.exports